import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialBoxProps {
  quote: string;
  author: string;
  location?: string;
  rating?: number;
  className?: string;
}
export function TestimonialBox({
  quote,
  author,
  location,
  rating = 5,
  className = ''
}: TestimonialBoxProps) {
  return <div className={`bg-white border-l-4 border-[#2d5016] p-6 my-8 shadow-sm rounded-r-lg ${className}`} data-id="element-108">
      <div className="flex gap-1 mb-3 text-yellow-500" data-id="element-109">
        {[...Array(rating)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-110" />)}
      </div>
      <blockquote className="text-lg italic text-gray-800 mb-4 leading-relaxed" data-id="element-111">
        "{quote}"
      </blockquote>
      <div className="flex items-center gap-3" data-id="element-112">
        <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center text-gray-500 font-bold text-sm" data-id="element-113">
          {author.charAt(0)}
        </div>
        <div data-id="element-114">
          <div className="font-bold text-gray-900" data-id="element-115">{author}</div>
          {location && <div className="text-sm text-gray-500" data-id="element-116">{location}</div>}
        </div>
      </div>
    </div>;
}